import React from 'react';
import { NpsCampaignDto } from '@area-restrita/api-client/model/npsCampaignDto';
import { EyeIcon } from 'lucide-react';

import Dialog from '@/components/template/Dialog';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  NPS_FIXED_QUESTION,
  NPS_SCALE_DESCRIPTION,
  NPS_STATUS_LABELS,
  formatDateRange,
  formatDateTime,
  formatParticipationRate,
} from '@/modules/nps/utils';

interface IProps {
  campaign: NpsCampaignDto;
  disabled?: boolean;
}

const NpsCampaignDetailsDialog: React.FC<IProps> = ({ campaign, disabled }) => (
  <Dialog
    title={campaign.name}
    description="Detalhes da campanha NPS."
    trigger={
      <Button variant="outline" size="icon-sm" disabled={disabled}>
        <EyeIcon data-icon="inline-start" />
      </Button>
    }
  >
    <dl className="grid grid-cols-[140px_1fr] gap-3 py-2 text-sm">
      <dt className="text-muted-foreground">Empresa</dt>
      <dd>{campaign.company.tradingName}</dd>

      <dt className="text-muted-foreground">Status</dt>
      <dd>
        <Badge variant="secondary">{NPS_STATUS_LABELS[campaign.status]}</Badge>
      </dd>

      <dt className="text-muted-foreground">Período</dt>
      <dd>{formatDateRange(campaign)}</dd>

      <dt className="text-muted-foreground">Pergunta</dt>
      <dd>
        <p>{campaign.question || NPS_FIXED_QUESTION}</p>
        <p className="text-muted-foreground">{NPS_SCALE_DESCRIPTION}</p>
      </dd>

      <dt className="text-muted-foreground">Respostas</dt>
      <dd>
        {campaign.responsesCount} de {campaign.eligibleUsersCount} elegíveis (
        {formatParticipationRate(campaign)})
      </dd>

      <dt className="text-muted-foreground">Aberta em</dt>
      <dd>{formatDateTime(campaign.openedAt)}</dd>

      <dt className="text-muted-foreground">Encerrada em</dt>
      <dd>{formatDateTime(campaign.closedAt)}</dd>

      <dt className="text-muted-foreground">Visibilidade</dt>
      <dd>
        Métricas: {campaign.metricsVisibleToCompany ? 'sim' : 'não'} ·
        Comentários: {campaign.commentsVisibleToCompany ? 'sim' : 'não'} ·
        Exportação: {campaign.exportAvailableToCompany ? 'sim' : 'não'}
      </dd>
    </dl>
  </Dialog>
);

export default NpsCampaignDetailsDialog;
